module.exports = __webpack_public_path__ + "static/media/Onboarding_One.261a9044.png";